var map = {
	"./Capture.PNG": "22fb",
	"./OE_logo.png": "5e0a",
	"./deltares-logo.png": "3fc1",
	"./dry.jpg": "505f",
	"./loading.gif": "f8b2",
	"./logo-m-2x.png": "bba8",
	"./map_sample.jpg": "d347",
	"./operational_platform.jpg": "74c8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";